import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const useThemeStore = create(
  persist(
    (set) => ({
      dayMode: false,
      toggleDayMode: () => set((s) => ({ dayMode: !s.dayMode })),
      setDayMode: (v) => set({ dayMode: !!v }),
    }),
    { name: 'firefleet.day-mode', storage: createJSONStorage(() => localStorage) },
  ),
);
